import { render, staticRenderFns } from "./Divide.vue?vue&type=template&id=2a918ef6"
import script from "./Divide.vue?vue&type=script&lang=js"
export * from "./Divide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports